module.exports = __webpack_public_path__ + "resources/img/img_appen_data1.33049abbfd39118745e1fbc5926c4751.png";